import * as React from 'react';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/lib/Async';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { SEARCH_TYPE, newI18n } from './Const';
import { HotelBedCatalogData, HotelBedData } from '../shared/index';
import { getAjaxhelper, getSearchDestinations, isNull, momentWrapper } from '../utils/index';
import { ModalWrapper } from './ModalWrapper';

export interface SelectDataWrapper {
    value?: any;
    label: string;
}
export interface SearchFormProps extends BaseComponentProps {
    showtitle: boolean;
    lang: string;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    style: string;
    count: number;
    externalFilter: HotelBedData.ExternalFilter;
    filter: HotelBedData.SearchFilter;
    onSearchHendler?: any;
    defaultSearch?: any;
    hotelCodes?: number[];
    specialPage?: boolean;
    initialSelectedValues?: SelectDataWrapper;
    // updateSearchFilter: (filter: HotelBedData.SearchFilter) => any;
}
export interface SearchFormState extends BaseComponentState {
    filter?: HotelBedData.SearchFilter;
    selectCreatable: boolean;
    selectValue: SelectDataWrapper;
    selectMulti: boolean;
    backspaceRemoves: boolean;
    isOpen: boolean;
    occupancies: { data: HotelBedData.OccupancieSearch[], room: number };
    btnOccupancies: string;
    dpCheckinInline: boolean;
    dpCheckOutInline: boolean;
    dpCheckInInlineClass: string;
    dpCheckOutInlineClass: string;
    dpCheckInInlineStyle: any;
    dpCheckOutInlineStyle: any;
    dpCheckInInlineBtn: string;
    dpCheckOutInlineBtn: string;
    dpCheckInInlineBtnText: string;
    dpCheckOutInlineBtnText: string;
    occMode: "MANUAL" | 'AUTO';
    accModeValue: boolean;
    autoRoomno: number;
    autoAdultno: number;
    autoChildno: number;
    autoChildAge: { [id: string]: number };
    mobileDp: string;
}
export class SearchForm extends BaseComponent<SearchFormProps, SearchFormState> {

    translation = {
        LocationorHotelName: newI18n("SEARCHFORM.LocationorHotelName", "Location or Hotel Name"),
        CheckIn: newI18n("SEARCHFORM.CheckIn", "Check In"),
        CheckOut: newI18n("SEARCHFORM.CheckOut", "Check Out"),
        Room: newI18n("SEARCHFORM.Room", "Room"),
        Adult: newI18n("SEARCHFORM.Adult", "Adult"),
        Children: newI18n("SEARCHFORM.Children", "Children"),
        Search: newI18n("SEARCHFORM.Search", "Search"),
        Manualroomsselection: newI18n("SEARCHFORM.Manualroomsselection", "Manual rooms selection"),
        ChildrenAge: newI18n("SEARCHFORM.ChildrenAge", "Children Age"),
        SearchHotels: newI18n("SEARCHFORM.SearchHotels", "Search Hotels")
    };

    constructor(props: SearchFormProps) {
        super(props);
        if (props.specialPage) {
            this.translation["Search"] = newI18n("SEARCHFORM.Search.special", "Show Deals");
            this.translation["SearchHotels"] = newI18n("SEARCHFORM.SearchHotels.special", "Find Bali's Best Hotel Deals");
        }
        let hotelCodes: number[] = [];
        if (!isNull(props.hotelCodes)) {
            hotelCodes = props.hotelCodes!;
        }
        let autoChildAge = {};
        let filter: any = {
            stay: {
                checkIn: momentWrapper().add(1, 'days'),
                checkOut: momentWrapper().add(3, 'days'),
            },
            occupancies: [{
                rooms: 1,
                adults: 2,
                children: 0
            }],
            hotels: {
                hotel: hotelCodes
            },
            destination: {
                code: null, zone: null
            }
        };
        let occupancies = {
            room: 1,
            data: [{
                adults: 2,
                rooms: 1,
                children: 0,
                paxes: []
            }]
        };
        let sessionFilter = props.filter;
        let btnOccupancies = `1 ${this.translation.Room}, 2 ${this.translation.Adult}, 0 ${this.translation.Children}`;
        let lop: number | any = 0;
        let dataOc: any[] = [];
        let jumA: number = 0;
        let jumC: number = 0;

        if (!isNull(sessionFilter)) {
            filter = sessionFilter;
            // console.log('Season Filter ', sessionFilter);
            // filter.stay.checkIn = moment(sessionFilter.stay.checkIn);
            // filter.stay.checkOut = moment(sessionFilter.stay.checkOut);

            for (let a of sessionFilter.occupancies!) {
                lop++;
                dataOc.push(
                    {
                        rooms: a.rooms,
                        adults: a.adults,
                        children: a.children,
                        paxes: isNull(a.paxes) ? [] : a.paxes
                    }
                );
                jumA += a.adults!;
                jumC += a.children!;
                let l = 0;
                if (!isNull(a.paxes) && a.paxes!.length > 0) {
                    for (let pax of a.paxes!) {
                        if (isNull(autoChildAge[l])) {
                            autoChildAge[l] = pax.age;
                        }
                        l++;
                    }
                }

            }

            occupancies = {
                room: lop,
                data: dataOc
            };
            // console.log('occupancies', occupancies);
            btnOccupancies = `${lop} ${this.translation.Room}, ${jumA} ${this.translation.Adult}, ${jumC} ${this.translation.Children}`;
        }

        this.state = {
            filter: filter,
            occupancies: occupancies,
            selectCreatable: false,
            selectValue: window["DESTINATION"] ? window["DESTINATION"] : props.initialSelectedValues ? props.initialSelectedValues : { label: '' },
            selectMulti: false,
            backspaceRemoves: true,
            isOpen: false,
            btnOccupancies: btnOccupancies,
            dpCheckinInline: false,
            dpCheckOutInline: false,
            dpCheckInInlineClass: 'hide',
            dpCheckOutInlineClass: 'hide',
            dpCheckInInlineStyle: { height: 32, padding: 0, zIndex: 999 },
            dpCheckOutInlineStyle: { height: 32, padding: 0, zIndex: 999 },
            dpCheckInInlineBtn: '',
            dpCheckOutInlineBtn: '',
            dpCheckInInlineBtnText: typeof filter.stay.checkIn === 'string' ? filter.stay.checkIn : filter.stay.checkIn.format("MM/DD/YYYY"),
            dpCheckOutInlineBtnText: typeof filter.stay.checkOut === 'string' ? filter.stay.checkOut : filter.stay.checkOut.format("MM/DD/YYYY"),
            occMode: 'AUTO', accModeValue: false, autoRoomno: lop, autoAdultno: jumA, autoChildno: jumC, autoChildAge: autoChildAge, mobileDp: "hide"
        };
    }

    componentDidMount() {
        return new Promise<any>(async (accpet: (n: any) => any, reject: (exc: any) => any) => {
            try {

                let desCode: string = window['DEFAULT_SEARCH_DEST'];
                if (!isNull(this.state.filter!.destination!.code) && this.state.filter!.destination!.code !== '') {
                    desCode = this.state.filter!.destination!.code!;
                }
                const q: any = {};
                if (desCode && desCode.length > 0) {
                    q.destinationsCode = { $eq: desCode };
                }
                /*
                if (this.state.filter && this.state.filter!.hotels && this.state.filter!.hotels.hotel && this.state.filter!.hotels.hotel.length === 1) {
                    q.originalId = { $eq: this.state.filter!.hotels.hotel[0]};
                } else {
*/
                if (this.state.filter && this.state.filter.destination && this.state.filter.destination.zone && this.state.filter.destination.zone && this.state.filter.destination.zone) {
                    q.ZoneCode = { $eq: this.state.filter.destination.zone };
                } else {
                    q.category_code = { $eq: '01_DESTINATION' };
                }
                // } 
                getAjaxhelper().post(`/dynamics/rest-api/generic/DestinationsFull`, {
                    eraseAuditTrail: true,
                    q: q,

                }).then((data) => {
                    let optHolder: any = {};
                    let tmp = window["DESTINATION"];
                    for (let element of data.rows) { 
                        if (tmp && tmp.value && tmp.value.ZoneCode) {
                            if (element.categoryCode === '02_ZONE' && element.ZoneCode === tmp.value.ZoneCode) {
                                optHolder = {
                                    'label': element.viewName,
                                    'value': {
                                        countryCode: element.countryCode,
                                        destinationsCode: element.destinationsCode,
                                        ZoneCode: element.ZoneCode,
                                        id: element.id
                                    }
                                };
                            }
                        } else if (tmp && tmp.value && tmp.value.destinationsCode) {
                            if (element.categoryCode === '01_DESTINATION' && element.destinationsCode === tmp.value.destinationsCode) {
                                optHolder = {
                                    'label': element.viewName,
                                    'value': {
                                        countryCode: element.countryCode,
                                        destinationsCode: element.destinationsCode,
                                        id: element.id,
                                        ZoneCode: null
                                    }
                                };
                            }
                        } else {
                            optHolder = {
                                'label': "Bali, Indonesia",
                                'value': {
                                    countryCode: "ID",
                                    destinationsCode: "BAI",
                                    ZoneCode: null
                                }
                            };
                        }

                    }
                    this.onChange(optHolder);
                    accpet({});
                }).catch(exc => {
                    // console.log(exc);
                    let optHolder: any = {};
                    optHolder = {
                        'label': "Bali, Indonesia",
                        'value': {
                            countryCode: "ID",
                            destinationsCode: "BAI",
                            ZoneCode: null
                        }
                    };
                    this.onChange(optHolder);
                    reject(exc);
                });

            } catch (exc) {
                // console.error(exc);
                reject(exc);
            }

        });
    }

    componentDidUpdate(prevProps: SearchFormProps, prevState: SearchFormState) {
        let haveChange: boolean = false;
        let filterChange: boolean = false;
        let hotelChange: boolean = false;
        let filterBaru: any = prevProps.filter;
        let hotelBaru: any = this.props.hotelCodes;
        if (prevProps.filter !== this.props.filter) {
            filterChange = true;
            filterBaru = this.props.filter;
            haveChange = true;
            // this.setStateHelper(st => { 
            //    st.filter = this.props.filter;
            // });
        }
        if (prevProps.hotelCodes !== this.props.hotelCodes) {
            hotelChange = true;
            hotelBaru = this.props.hotelCodes;
            haveChange = true;
        }

        if (haveChange) {
            this.setStateHelper(st => {
                if (filterChange) {
                    st.filter = filterBaru;
                }
                if (hotelChange) {
                    if (!isNull(hotelBaru)) {
                        st.filter!.hotels = {};
                        st.filter!.hotels = {
                            hotel: hotelBaru
                        };
                    }
                }

            });
        }

    }

    toggleCreatable: () => any = () => {
        this.setStateHelper(st => st.selectCreatable = !st.selectCreatable);
    }

    /**
     * { value: any, label: string  }
     */
    onChange: (val: SelectDataWrapper) => any = (value: SelectDataWrapper) => {
        // const value: any = JSON.parse(val.value);
        console.log("Locatioan Diganti Dari");
        window["DESTINATION"] = value;
        this.setStateHelper(st => {
            st.selectValue = value;
            st.filter!.destination = {
                id: value && value.value && value.value.id ? value.value.id : null,
                code: value && value.value && value.value.destinationsCode ? value.value.destinationsCode : null,
                zone: value && value.value && value.value.ZoneCode ? value.value.ZoneCode : null,
                hotelCode: value && value.value && value.value.hotelCode! ? value.value.hotelCode! : null
            };
            if (!isNull(value) && !isNull(value.value) && !isNull(value.value.hotelCode)) {
                st.filter!.hotels = {
                    hotel: [value.value.hotelCode]
                };
            }
        }
        );
    }

    getOptionDestination: (input: string) => Promise<any> = (input: string) => {
        if (!input) {
            return Promise.resolve({ options: [] });
        }
        return new Promise<any>(async (accpet: (n: any) => any, reject: (exc: any) => any) => {
            try {
                let optHolder: any[] = [];
                let des: HotelBedCatalogData.DestinationsFull[] = await getSearchDestinations(false, this.props.lang, input);
                for (let element of des) {
                    if (element.categoryCode === '03_HOTEL') {
                        optHolder.push({
                            'label': element.viewName,
                            'value': {
                                hotelCode: element.originalId,
                                countryCode: element.countryCode,
                                destinationsCode: element.destinationsCode,
                                ZoneCode: element.ZoneCode,
                                id: element.id
                            }
                        });
                    } else {
                        optHolder.push({
                            'label': element.viewName,
                            'value': {
                                countryCode: element.countryCode,
                                destinationsCode: element.destinationsCode,
                                ZoneCode: element.ZoneCode,
                                id: element.id
                            }
                        });
                    }

                }
                accpet(optHolder);
            } catch (exc) {
                // console.error(exc);
                reject(exc);
            }

        });
    }

    renderTitle: () => any = () => {
        if (this.props.showtitle) {
            return (
                <div
                    className="panel-heading border-light"
                    style={{ backgroundColor: '#ffffff80' }}
                >
                    <h4 className="panel-title">{this.translation.SearchHotels} </h4>
                </div>);
        } else {
            return <span />;
        }

    }

    onButtonToggleOpen: () => any = () => {
        //
        this.setStateHelper(st => st.isOpen = true);
    }
    onSearchButtonClicked: (event: any) => any = (event: any) => {
        if (typeof this.props.onSearchHendler === 'undefined') {
            this.props.getHotels(this.props.lang, 0, 15, this.state.filter as any, { destinations: [this.state!.selectValue!.value] });
        } else {
            this.props.onSearchHendler();
        }
    }

    onUpdateOccupancyButtonClick: (event: any) => any = (event: any) => {
        this.setStateHelper(
            st => {
                if (isNull(st.filter)) {
                    st.filter = {
                    };
                }
                st.filter!.occupancies = [];
                let filteroccupancies: HotelBedData.OccupancieSearch[] = [];
                for (let x of st.occupancies.data) {
                    filteroccupancies.push({
                        adults: x!.adults,
                        children: x.children,
                        rooms: 1,
                        paxes: x.paxes
                    });
                }
                st.filter!.occupancies = filteroccupancies;
            },
            () => {
                let jumAdult = 0;
                let jumchild = 0;
                let jumRoom = 0;
                for (let a of this.state!.filter!.occupancies as HotelBedData.OccupancieSearch[]) {
                    jumAdult += a!.adults as number;
                    jumchild += a!.children as number;
                    jumRoom += a!.rooms as number;
                }
                this.setStateHelper(st => {
                    st.btnOccupancies = `${jumRoom} ${this.translation.Room}, ${jumAdult} ${this.translation.Adult}, ${jumchild} ${this.translation.Children}`;
                    st.isOpen = false;
                });
            });
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let className = '';
        let roomsLabel = '';
        let wherehide = '';
        if (this.props.style === 'horisontal') {
            className = "col-md-";
            roomsLabel = 'hide';
        } else if (this.props.style === 'vertical') {
            className = "col-md-12 ";
        } else if (this.props.style === 'hotelDetail') {
            className = "col-md-6 ";
            wherehide = ' hide';
            roomsLabel = 'hide';
        }
        let style: ReactModal.Styles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0, 0.75)',
                zIndex: 9999
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                padding: 0
            }
        };
        let checkoutDate: any = this.state.filter!.stay!.checkOut;
        let checkInDate: any = this.state.filter!.stay!.checkIn;
        if (checkoutDate && typeof checkoutDate === 'string') {
            checkoutDate = momentWrapper(checkoutDate);
        }
        if (checkInDate && typeof checkInDate === 'string') {
            checkInDate = momentWrapper(checkInDate);
        }
        this.state.filter!.stay!.checkOut = checkoutDate;
        this.state.filter!.stay!.checkIn = checkInDate;
        // console.log("stateFilte: ",this.state.filter)

        const customStyles = {
            option: (base: any, state: any) => ({
                ...base,
                borderBottom: '1px dotted #eee'
            })
        };

        let SearcText = (
            <AsyncSelect
                styles={customStyles}
                className={`syncSelect`}
                value={this.state.selectValue}
                onChange={this.onChange}
                loadOptions={this.getOptionDestination}
                placeholder='Select Location'
            />);
        let searchType = SEARCH_TYPE;
        if (searchType === "google") {
            SearcText = <input id="autocomplete" placeholder="Enter your address" type="text" />;
        }
        let occDetail = <span />;
        if (this.state.occMode === 'AUTO') {
            occDetail = this.renderAutoOccMode();
        } else {
            occDetail = this.renderManualOccMode();
        }
        return (
            <div className={"panel " + this.props.style} style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)' }}>
                {this.renderTitle()}
                <div className="panel-body" style={{ paddingBottom: 0 }}>
                    <div className={className + '3' + wherehide}>
                        <div className={"form-group " + this.props.style + " bgwhite"} style={{ paddingBottom: 2 }}>
                            <label className="search-where">
                                {this.translation.LocationorHotelName}
                            </label>
                            {SearcText}
                        </div>
                    </div>
                    <div className={className + '3'}>
                        <div className='row'>
                            <div className={"form-group col-sm-6 check-in desktop-only " + this.props.style}>
                                <label>
                                    {this.translation.CheckIn}
                                </label>
                                <DatePicker
                                    selected={this.state.filter && this.state.filter!.stay ? this.state.filter!.stay!.checkIn as any : null}
                                    selectsStart={true}
                                    peekNextMonth={true}
                                    showMonthDropdown={true}
                                    showYearDropdown={true}
                                    startDate={this.state.filter && this.state.filter!.stay ? this.state.filter!.stay!.checkIn as any : null}
                                    endDate={this.state.filter && this.state.filter!.stay ? this.state.filter!.stay!.checkOut as any : null}
                                    onChange={(date: any) => {
                                        let netTGl = momentWrapper(date);
                                        // console.log("netTGl", netTGl);
                                        if (this.state.filter && this.state.filter!.stay) {
                                            let endDates = this.state.filter!.stay!.checkOut;
                                            if (this.state.filter!.stay!.checkOut < date) {
                                                endDates = date.add({ days: 2 });
                                            }
                                            this.setStateHelper(st => {
                                                // console.log("netTGl2", netTGl);
                                                if (st.filter && st.filter!.stay) {
                                                    st.filter!.stay!.checkIn = netTGl;
                                                    st.filter!.stay!.checkOut = endDates;
                                                }
                                            });
                                        }

                                    }}
                                />
                            </div>
                            <div className={"form-group col-sm-6 check-in mobile-only  " + this.props.style}>
                                <label>
                                    {this.translation.CheckIn}
                                </label>
                                <button
                                    type="button"
                                    className={`form-control ${this.state.dpCheckInInlineBtn}`}
                                    style={this.state.dpCheckInInlineStyle}
                                    onClick={
                                        () => {
                                            this.setStateHelper(
                                                st => {
                                                    st.dpCheckinInline = true;
                                                    st.dpCheckInInlineBtn = 'hide';
                                                    st.dpCheckInInlineClass = '';
                                                    st.mobileDp = "";
                                                });
                                        }
                                    }
                                > {this.state.dpCheckInInlineBtnText}
                                </button>
                            </div>
                            <div className={"form-group col-sm-6 check-out desktop-only " + this.props.style}>
                                <label>
                                    {this.translation.CheckOut}
                                </label>
                                <DatePicker
                                    selected={this.state.filter && this.state.filter!.stay ? this.state.filter!.stay!.checkOut as any : null}
                                    selectsEnd={true}
                                    peekNextMonth={true}
                                    showMonthDropdown={true}
                                    showYearDropdown={true}
                                    minDate={this.state.filter && this.state.filter!.stay ? this.state.filter!.stay!.checkIn : null}
                                    startDate={this.state.filter && this.state.filter!.stay ? this.state.filter!.stay!.checkIn : null}
                                    endDate={this.state.filter && this.state.filter!.stay ? this.state.filter!.stay!.checkOut : null}
                                    onChange={(date: any) => {
                                        this.setStateHelper(st => {
                                            let s: any = date;
                                            st.filter!.stay!.checkOut = s;
                                        });
                                    }}
                                />
                            </div>
                            <div className={"form-group col-sm-6 check-out mobile-only " + this.props.style}>
                                <label>
                                    {this.translation.CheckOut}
                                </label>
                                <button
                                    type="button"
                                    className={`form-control ${this.state.dpCheckOutInlineBtn}`}
                                    style={this.state.dpCheckOutInlineStyle}
                                    onClick={
                                        () => {
                                            this.setStateHelper(
                                                st => {
                                                    st.dpCheckOutInline = true;
                                                    st.dpCheckOutInlineBtn = 'hide';
                                                    st.dpCheckOutInlineClass = '';
                                                    st.mobileDp = "";
                                                });
                                        }
                                    }
                                > {this.state.dpCheckOutInlineBtnText}
                                </button>
                            </div>
                            <div className={`col-xs-12 ${this.state.mobileDp} `}>
                                <DatePicker
                                    className={`${this.state.dpCheckInInlineClass}`}
                                    inline={this.state.dpCheckinInline}
                                    selected={this.state.filter && this.state.filter.stay ? this.state.filter.stay.checkIn as any : null}
                                    selectsStart={true}
                                    peekNextMonth={true}
                                    showMonthDropdown={true}
                                    showYearDropdown={true}
                                    startDate={this.state.filter && this.state.filter.stay ? this.state.filter.stay.checkIn as any : null}
                                    endDate={this.state.filter && this.state.filter.stay ? this.state.filter.stay.checkOut as any : null}
                                    onChange={(date: any) => {
                                        let netTGl = momentWrapper(date);
                                        if (this.state.filter && this.state.filter.stay) {
                                            let endDates = this.state.filter.stay.checkOut;
                                            if (this.state.filter.stay.checkOut < date) {
                                                endDates = date.add({ days: 2 });
                                            }
                                            this.setStateHelper(st => {
                                                if (st.filter && st.filter.stay) {
                                                    st.filter.stay.checkIn = netTGl;
                                                    st.filter.stay.checkOut = endDates;
                                                    st.mobileDp = "hide";
                                                    st.dpCheckinInline = false;
                                                    st.dpCheckInInlineClass = 'hide';
                                                    // st.dpCheckInInlineStyle = { height: 32, padding: 0, marginTop: '-20px', marginBottom: '-20px' };
                                                    st.dpCheckInInlineBtn = '';
                                                    st.dpCheckInInlineBtnText = netTGl.format("MM/DD/YYYY");
                                                }
                                            });
                                        }

                                    }}
                                />
                                <DatePicker
                                    className={`${this.state.dpCheckOutInlineClass}`}
                                    inline={this.state.dpCheckOutInline}
                                    selected={this.state.filter && this.state.filter.stay ? this.state.filter.stay.checkOut as any : null}
                                    selectsEnd={true}
                                    peekNextMonth={true}
                                    showMonthDropdown={true}
                                    showYearDropdown={true}
                                    minDate={this.state.filter && this.state.filter.stay ? this.state.filter.stay.checkIn : null}
                                    startDate={this.state.filter && this.state.filter.stay ? this.state.filter.stay.checkIn : null}
                                    endDate={this.state.filter && this.state.filter.stay ? this.state.filter.stay.checkOut : null}
                                    onChange={(date: any) => {
                                        this.setStateHelper(st => {
                                            let s: any = date;
                                            st.filter!.stay!.checkOut = s;
                                            st.mobileDp = "hide";
                                            st.dpCheckOutInline = false;
                                            st.dpCheckOutInlineClass = 'hide';
                                            // st.dpCheckInInlineStyle = { height: 32, padding: 0, marginTop: '-20px', marginBottom: '-20px' };
                                            st.dpCheckOutInlineBtn = '';
                                            st.dpCheckOutInlineBtnText = s.format("MM/DD/YYYY");
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={className + '6'}>
                        <div className=' row'>
                            <div className={"form-group col-md-6 noborder " + this.props.style}>
                                <label className={roomsLabel}>
                                    {this.translation.Room}
                                </label>
                                <button
                                    type='button'
                                    style={{ height: 58, padding: 0 }}
                                    className="form-control"
                                    onClick={this.onButtonToggleOpen}
                                >{this.state.btnOccupancies}
                                </button>
                            </div>
                            <div className={"form-group col-md-6 noborder " + this.props.style}>
                                <label className={roomsLabel}>&nbsp;</label>
                                <button
                                    type='button'
                                    style={{ height: 57 }}
                                    className="btn btn-primary form-control"
                                    onClick={this.onSearchButtonClicked}
                                > {this.translation.Search}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                <ModalWrapper style={style} isOpen={this.state.isOpen} onRequestClose={this.hengleUserDialogClose} role="dialog" contentLabel="Minimal Modal Example"  >
                    <div style={{ minWidth: 200, maxWidth: 500, padding: 20, overflowY: 'scroll', overflowX: 'hidden', maxHeight: 500 }}>
                        <h3>Occupancies Detail</h3>
                        <div className="checkbox clip-check check-primary  checkbox-inline">
                            <input
                                type='checkbox'
                                className=""
                                onClick={
                                    () => {
                                        this.setStateHelper(
                                            st => {
                                                st.occMode = st.occMode === 'AUTO' ? 'MANUAL' : 'AUTO';
                                                st.accModeValue = st.accModeValue === false ? true : false;
                                            }
                                        );
                                    }
                                }
                                checked={this.state.accModeValue}
                            />
                            <label
                                onClick={
                                    () => {
                                        this.setStateHelper(
                                            st => {
                                                st.occMode = st.occMode === 'AUTO' ? 'MANUAL' : 'AUTO';
                                                st.accModeValue = st.accModeValue === false ? true : false;
                                            }
                                        );
                                    }
                                }
                            >{this.translation.Manualroomsselection}
                            </label>
                        </div>
                        <hr />
                        {occDetail}
                    </div>
                </ModalWrapper>
            </div>
        );
    }

    renderManualOccMode: () => any = () => {
        return (
            <div className="row" style={{}}>
                <div className="form-group col-md-3">
                    <label>{this.translation.Room}</label>
                    <div className="input-group bootstrap-touchspin">
                        <span className="input-group-btn">
                            <button
                                className="btn btn-default bootstrap-touchspin-down"
                                type="button"
                                onClick={() => {
                                    this.setStateHelper(st => {
                                        let x = st.occupancies.room - 1;
                                        if (x > 0) {
                                            st.autoRoomno = x;
                                            st.occupancies.room = x;
                                            st.occupancies.data.splice(-1, 1);
                                        }
                                    });
                                }}
                            >-
                            </button>
                        </span>
                        <span className="input-group-addon bootstrap-touchspin-prefix" style={{ display: 'none' }}>{/**/}</span>
                        <input type="text" value={this.state.occupancies.room} className="form-control" style={{ display: 'block' }} />
                        <span className="input-group-btn">
                            <button
                                className="btn btn-default bootstrap-touchspin-up"
                                type="button"
                                onClick={() => {
                                    this.setStateHelper(st => {
                                        let x = st.occupancies.room + 1;
                                        st.occupancies.room = x;
                                        let newData: HotelBedData.OccupancieSearch = {
                                            rooms: x, adults: 2, children: 0, paxes: []
                                        };
                                        st.occupancies.data.push(newData);
                                    });
                                }}
                            >+
                            </button>
                        </span>
                    </div>
                </div>
                <div className="form-group col-md-9">
                    {this.renderTabOccupancies()}
                    <button type='button' className="btn btn-primary form-control" onClick={this.onUpdateOccupancyButtonClick}>Update</button>
                </div>
            </div>
        );
    }

    renderAutoOccMode: () => any = () => {
        return (
            <div>
                <div className="form-group col-md-4">
                    <label>{this.translation.Room}</label>
                    <div className="input-group bootstrap-touchspin">
                        <span className="input-group-btn">
                            <button
                                className="btn btn-default bootstrap-touchspin-down"
                                type="button"
                                onClick={() => {
                                    this.setStateHelper(st => {
                                        let x = st.autoRoomno - 1;
                                        if (x > 0) {
                                            st.occupancies.room = x;
                                            st.autoRoomno = x;
                                            if (st.autoAdultno > x * 3) {
                                                st.autoAdultno = x * 3;
                                            }
                                            if (st.autoChildno > x * 3) {
                                                st.autoChildno = x * 3;
                                            }
                                        }
                                    });
                                }}
                            >-
                            </button>
                        </span>
                        <span className="input-group-addon bootstrap-touchspin-prefix" style={{ display: 'none' }}>{/**/}</span>
                        <input type="text" value={this.state.autoRoomno} className="form-control" style={{ display: 'block' }} />
                        <span className="input-group-btn">
                            <button
                                className="btn btn-default bootstrap-touchspin-up"
                                type="button"
                                onClick={() => {
                                    this.setStateHelper(st => {
                                        let x = st.autoRoomno + 1;
                                        st.autoRoomno = x;
                                        if (st.autoAdultno < x) {
                                            st.autoAdultno = x;
                                        }
                                    });
                                }}
                            >+
                            </button>
                        </span>
                    </div>
                </div>
                <div className='col-md-8'>
                    <div className="  col-md-6">
                        <label>#{this.translation.Adult}</label>
                        <div className="input-group bootstrap-touchspin">
                            <span className="input-group-btn">
                                <button
                                    className="btn btn-default bootstrap-touchspin-down"
                                    type="button"
                                    onClick={() => {
                                        this.setStateHelper(st => {
                                            let x = st.autoAdultno - 1;
                                            if (x >= st.autoRoomno) {
                                                st.autoAdultno = x;
                                            }
                                        });
                                    }}
                                >-
                                </button>
                            </span>
                            <span className="input-group-addon bootstrap-touchspin-prefix" style={{ display: 'none' }}>{/**/}</span>
                            <input type="text" value={this.state.autoAdultno} className="form-control" style={{ display: 'block' }} />
                            <span className="input-group-btn">
                                <button
                                    className="btn btn-default bootstrap-touchspin-up"
                                    type="button"
                                    onClick={() => {
                                        this.setStateHelper(st => {
                                            let x = st.autoAdultno + 1;
                                            if (st.autoRoomno * 3 >= x) {
                                                st.autoAdultno = x;
                                            }
                                        });
                                    }}
                                >+
                                </button>
                            </span>
                        </div>
                    </div>

                    <div className=" col-md-6">
                        <label>#{this.translation.Children} </label>
                        <div className="input-group bootstrap-touchspin">
                            <span className="input-group-btn">
                                <button
                                    className="btn btn-default bootstrap-touchspin-down"
                                    type="button"
                                    onClick={() => {
                                        this.setStateHelper(st => {
                                            let x = st.autoChildno - 1;
                                            if (x >= 0) {
                                                st.autoChildno = x;
                                            }
                                        });
                                    }}
                                >-
                                </button>
                            </span>
                            <span className="input-group-addon bootstrap-touchspin-prefix" style={{ display: 'none' }}>{/**/}</span>
                            <input type="text" value={this.state.autoChildno} className="form-control" style={{ display: 'block' }} />
                            <span className="input-group-btn">
                                <button
                                    className="btn btn-default bootstrap-touchspin-up"
                                    type="button"
                                    onClick={() => {
                                        this.setStateHelper(st => {
                                            let x = st.autoChildno + 1;
                                            if (st.autoRoomno * 3 >= x) {
                                                st.autoChildno = x;
                                                for (let i = 0; i < x; i++) {
                                                    if (isNull(st.autoChildAge[i])) {
                                                        st.autoChildAge[i] = 0;
                                                    }
                                                }
                                            }
                                        });
                                    }}
                                >+
                                </button>
                            </span>
                        </div>
                    </div>
                    {this.renderChildAutoInput()}
                    <button type='button' className="btn btn-primary form-control" onClick={this.onUpdateOccupancyAutoButtonClick}>Update</button>
                </div>
            </div>
        );
    }
    onUpdateOccupancyAutoButtonClick: () => any = () => {
        // let occupancies: { data: HotelBedData.OccupancieSearch[], room: number };
        // occupancies.room = this.state.autoRoomno;
        getAjaxhelper().post(`/dynamics/rest-api/generic/SearchFilterCombination`, {
            "eraseAuditTrail": true,
            q: {
                room_no: this.state.autoRoomno,
                adult_no: this.state.autoAdultno,
                child_no: this.state.autoChildno
            },
        }).then(
            (d: any) => {
                let ocs = d.rows;
                console.log("ocs", ocs);
                let ocdetail: HotelBedData.OccupancieSearch[] = [];
                let occh = 0;
                for (let oc of ocs) {
                    let o: HotelBedData.OccupancieSearch = {};
                    o = {
                        rooms: 1,
                        adults: oc.adult_query,
                        children: oc.child_query
                    };
                    let p: HotelBedData.Paxe[] = [];
                    if (oc.child_query > 0) {
                        for (let i = 0; i < oc.child_query; i++) {
                            p.push({
                                type: 'CH',
                                age: this.state.autoChildAge[occh]
                            });
                            occh++;
                        }
                        o = {
                            rooms: 1,
                            adults: oc.adult_query,
                            children: oc.child_query,
                            paxes: p
                        };
                    }
                    ocdetail.push(o);
                }
                this.setStateHelper(
                    st => {
                        st.filter!.occupancies = ocdetail;
                        st.isOpen = false;
                        st.btnOccupancies = `${this.state.autoRoomno} ${this.translation.Room}, ${this.state.autoAdultno} ${this.translation.Adult}, ${this.state.autoChildno} ${this.translation.Children}`;
                    }
                );
                console.log(ocdetail);
            }).catch((exc) => { console.error('error: ', exc); });
    }

    renderChildAutoInput: () => any = () => {
        let child: any[] = [];
        let title = <span />;
        for (let x = 0; x < this.state.autoChildno; x++) {
            title = <h4 className='col-md-12' style={{ marginTop: 15 }}>{this.translation.ChildrenAge}</h4>;
            let selVal = this.state.autoChildAge[x];
            child.push(this.renderChildAutoInputSelect(x, selVal));
        }
        return (
            <div className="row" style={{ margin: '0 0 15px 0' }}>
                {title}
                {child}
            </div>

        );
    }
    renderChildAutoInputSelect: (x: number, selecVal: any) => any = (x: number, selecVal: any) => {
        let selects: any[] = [];
        for (let k = 0; k < 18; k++) {
            selects.push(<option key={`${x}.${k}`} >{k}</option>);
        }
        return (
            <div className="col-xs-4 margin-top-10">
                <select
                    key={x}
                    value={selecVal}
                    onChange={
                        (evt) => {
                            let v: any = evt.target.value as any / 1;
                            this.setStateHelper(
                                st => {
                                    st.autoChildAge[x] = v;
                                }
                            );
                        }
                    }
                >
                    {selects}
                </select>
            </div>
        );
    }

    renderTabpanel: (key: number) => JSX.Element = (key: number) => {
        let inpVal: any = '';
        if (!isNull(this.state!.occupancies) && !isNull(this.state!.occupancies!.data[key])) {
            inpVal = this.state.occupancies.data[key].adults as number;
        }
        return (
            <div className="row" key={key}>
                <div className="row" key={key + 'b'}>
                    <label className="col-md-3">{this.translation.Room} {key + 1}</label>
                    <div className="col-md-9  "  >
                        <div className="form-group col-md-6">
                            <label>{this.translation.Adult}</label>
                            <div className="input-group bootstrap-touchspin">
                                <span className="input-group-btn">
                                    <button
                                        className="btn btn-default bootstrap-touchspin-down"
                                        type="button"
                                        onClick={() => {
                                            this.setStateHelper(st => {
                                                if (st.occupancies.data[key].adults! > 1) {
                                                    st!.occupancies.data[key].adults!--;
                                                }
                                            });
                                        }}
                                    >-
                                    </button>
                                </span>
                                <span className="input-group-addon bootstrap-touchspin-prefix" style={{ display: 'none' }}>{/**/}</span>
                                <input type="text" value={inpVal} className="form-control" style={{ display: 'block' }} />
                                <span className="input-group-btn">
                                    <button
                                        className="btn btn-default bootstrap-touchspin-up"
                                        type="button"
                                        onClick={() => {
                                            this.setStateHelper(st => {
                                                st.occupancies.data[key].adults!++;
                                            });
                                        }}
                                    >
                                        +
                                    </button>
                                </span>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label>{this.translation.Children}</label>
                            <div className="input-group bootstrap-touchspin">
                                <span className="input-group-btn">
                                    <button
                                        className="btn btn-default bootstrap-touchspin-down"
                                        type="button"
                                        onClick={() => {
                                            this.setStateHelper(st => {
                                                if (st.occupancies.data[key].children! > 0) {
                                                    st.occupancies.data[key].children!--;
                                                    st.occupancies.data[key].paxes!.splice(-1, 1);
                                                }
                                            });
                                        }}
                                    >-
                                    </button>
                                </span>
                                <span className="input-group-addon bootstrap-touchspin-prefix" style={{ display: 'none' }}>{/**/}</span>
                                <input type="text" value={this.state.occupancies.data[key].children} className="form-control" style={{ display: 'block' }} />
                                <span className="input-group-btn">
                                    <button
                                        className="btn btn-default bootstrap-touchspin-up"
                                        type="button"
                                        onClick={() => {
                                            this.setStateHelper(st => {
                                                st.occupancies.data[key].children!++;
                                                st.occupancies.data[key].paxes!.push({ age: 0, type: 'CH' });
                                            });
                                        }}
                                    >
                                        +
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" key={key + 'a'}>
                    <label className="col-md-3">{}</label>
                    <div className="col-md-9" >
                        {(() => {

                            if (this.state.occupancies.data[key].children! > 0) {
                                return <label className="col-md-12">{this.translation.ChildrenAge}</label>;
                            } else {
                                return <span />;
                            }
                        })()}
                        {(() => {
                            let child: any[] = [];
                            for (let j = 0; j < this.state.occupancies.data[key].children!; j++) {
                                let selects: any[] = [];
                                for (let k = 0; k < 18; k++) {
                                    selects.push(<option key={`${j}.${k}`} >{k}</option>);
                                }
                                let selecVal: any = 0;
                                if (!isNull(this.state.occupancies) && !isNull(this.state.occupancies.data) && !isNull(this.state.occupancies.data[key]) && !isNull(this.state.occupancies.data[key].paxes![j]) && !isNull(this.state.occupancies.data[key].paxes![j].age)) {
                                    selecVal = this.state.occupancies.data[key].paxes![j].age;
                                }

                                let occ = this.createSelectPaxis(key, j, selecVal, selects);
                                child.push(
                                    occ
                                );
                            }
                            return child;
                        })()}

                    </div>
                </div>

            </div>
        );
    }

    createSelectPaxis: (key: number, j: number, selecVal: number, selects: any) => any = (key: number, j: number, selecVal: number, selects: any) => {
        return (
            <div className="col-md-4" style={{ marginBottom: 20 }}>
                <select
                    className="form-control"
                    value={selecVal}
                    onChange={
                        (event) => {
                            let val = event.target.value;
                            this.setStateHelper(
                                st => {
                                    st.occupancies.data[key].paxes![j].age = val as any / 1;
                                }
                            );

                        }
                    }
                >
                    {selects}
                </select >
            </div>
        );
    }

    renderTabOccupancies: () => any = () => {
        // console.log("Search hendler State", this.state);
        let tabPanel: any[] = [];
        for (let i = 0; i < this.state.occupancies.room; i++) {
            tabPanel.push(this.renderTabpanel(i));
        }
        return (
            <div>
                {tabPanel}
            </div>
        );
    }

    hengleUserDialogClose: () => any = () => {
        this.setState({ isOpen: false });
    }
}



// WEBPACK FOOTER //
// ./src/core/SearchForm.tsx